import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=0525f287&"
import script from "./Version.vue?vue&type=script&lang=js&"
export * from "./Version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports